import React from "react";

const Navbar = ({ client, handleGiftcardClick, handlePromoBtnClick }) => {
  return (
    <div className="gog-client-actions">
      <button
        type="button"
        onClick={() => handleGiftcardClick(client?.clientId)}
        disabled={!client?.sellGiftCards}
        className="gog-action-btn gog-action-primary"
      >
        Buy Gift Card
      </button>

      <button
        type="button"
        onClick={() => handlePromoBtnClick(client?.clientId)}
        disabled={!client?.offerPromotion}
        className="gog-action-btn gog-action-secondary"
      >
        Promotions
      </button>
    </div>
  );
};

export default Navbar;